import classNames from 'classnames'
import React from 'react'
import {
  isNullOrWhiteSpace,
  sanitizeHtmlAndReplaceNewlines,
} from '../../utilities/string'
import { Grid } from '../Grid'

export interface TwoTextsProps {
  firstSubtitle?: string
  firstText?: string
  firstTitle?: string
  secondSubtitle?: string
  secondText?: string
  secondTitle?: string
}

const commonTextClassName = classNames(
  'font-body text-body text-secondary-darker text-center',
  'mx-15',
  'tb:mx-0',
  'sm:text-left',
  'xl:mr-150',
  'xxl:mr-0'
)

const commonSubtitleClassName = classNames(
  'mb-20 font-h4 text-h4 text-secondary-darker text-center',
  'tb:mb-10',
  'sm:mb-30 sm:text-left'
)

const commonTitleClassName = classNames(
  'mb-20 font-h2 text-h2 text-secondary-dark text-center',
  'tb:mb-10',
  'sm:text-left',
  'lg:mb-15',
  'xl:mb-20 xl:mr-90',
  'xxl:mr-0'
)

export const TwoTexts = ({
  firstSubtitle,
  firstText,
  firstTitle,
  secondSubtitle,
  secondText,
  secondTitle,
}: TwoTextsProps) => {
  const firstBlockExists =
    !isNullOrWhiteSpace(firstSubtitle) ||
    !isNullOrWhiteSpace(firstText) ||
    !isNullOrWhiteSpace(firstTitle)

  const secondBlockExists =
    !isNullOrWhiteSpace(secondSubtitle) ||
    !isNullOrWhiteSpace(secondText) ||
    !isNullOrWhiteSpace(secondTitle)

  return (
    <Grid additionalClassName="gap-y-45">
      {firstBlockExists && (
        <div
          className={classNames(
            'col-span-full flex flex-col',
            'tb:mx-150',
            'sm:col-start-2 sm:col-span-2 sm:ml-0 sm:mr-60',
            'md:col-start-1 md:col-span-2 md:mr-0',
            'lg:col-start-2 lg:col-span-2',
            'xl:col-start-2 xl:col-span-3',
            'xxl:col-start-3 xxl:col-span-3'
          )}
        >
          {!isNullOrWhiteSpace(firstTitle) && (
            <h2 className={commonTitleClassName}>{firstTitle}</h2>
          )}

          {!isNullOrWhiteSpace(firstSubtitle) && (
            <h3 className={commonSubtitleClassName}>{firstSubtitle}</h3>
          )}

          {!isNullOrWhiteSpace(firstText) && (
            <p
              className={commonTextClassName}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtmlAndReplaceNewlines(firstText),
              }}
            />
          )}
        </div>
      )}

      {secondBlockExists && (
        <div
          className={classNames(
            'col-span-full flex flex-col',
            'tb:mx-150',
            'sm:col-start-4 sm:col-span-2 sm:ml-30 sm:mr-20',
            'md:col-start-4 md:col-span-2 md:mx-0',
            'lg:col-start-5 lg:col-span-2',
            'xl:col-start-6 xl:col-span-3',
            'xxl:col-start-8 xxl:col-span-3'
          )}
        >
          {!isNullOrWhiteSpace(secondTitle) && (
            <h2 className={commonTitleClassName}>{secondTitle}</h2>
          )}

          {!isNullOrWhiteSpace(secondSubtitle) && (
            <h3 className={commonSubtitleClassName}>{secondSubtitle}</h3>
          )}

          {!isNullOrWhiteSpace(secondText) && (
            <p
              className={commonTextClassName}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtmlAndReplaceNewlines(secondText),
              }}
            />
          )}
        </div>
      )}
    </Grid>
  )
}
